module.exports = __webpack_public_path__ + "static/media/notice.9c3ff303.svg";